import React from 'react';

import classes from './ActivityIdCell.module.scss';

interface Props {
    activityId: string | undefined;
}

export const ActivityIdCell = ({ activityId }: Props) => {
    return (
        <div className={classes.ActivityIdCell} data-testid={'activity-id-name'}>
            {activityId}
        </div>
    );
};
